import { gpx } from "@tmcw/togeojson"
import simplify from "@turf/simplify";

export async function loadGpx(event:Event) : Promise<number[][]|void> {

	return new Promise((resolve, reject) => {
		const target = <HTMLInputElement>event.target;
		if(target.files && target.files.length) {
	
			const file = target.files[0];
			const reader = new FileReader();
			reader.onload = e => {
				const result = e.target ? e.target.result as string : undefined;
				if(result) {
					const featureCollection = gpx(new DOMParser().parseFromString(result, "text/xml"))
					console.log(featureCollection)
					if(featureCollection.features[0]){
						const feature = simplify(featureCollection.features[0], {tolerance:0.00002, highQuality:true})
						resolve(feature.geometry.coordinates.map(coords => coords.slice(0,2)));
						return;
					}
				}
				reject();
			};
			reader.readAsText(file);
		} else {
			reject();
		}
	});
}
	